<template>
  <section class="about-section">
    <div class="section-container">
      <div class="about-grid">
        <div class="about-content">
          <span class="section-label">À propos de nous</span>
          <h2 class="section-title">OASIS FINANCE : L'inclusion financière au Cameroun</h2>
          <p class="section-subtitle">
            En Afrique, l'accès aux services financiers reste un défi majeur. 
            OASIS FINANCE s'engage à rendre la finance accessible à tous.
          </p>
          <p class="about-text">
            Basée à Ngaoundéré, OASIS FINANCE est une institution de microfinance 
            qui s'est imposée comme un acteur majeur de l'inclusion financière depuis 2019. 
            Notre mission est de rendre les services financiers accessibles à tous, 
            particuliers comme entrepreneurs, avec des solutions adaptées et un accompagnement personnalisé.
          </p>

          <div class="about-stats">
            <div class="stat-item" v-for="stat in stats" :key="stat.label">
              <div class="stat-number">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div>

        <div class="about-images">
          <div class="about-img" v-for="(image, index) in images" :key="index">
            <img :src="image.src" :alt="image.alt">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  data() {
    return {
      stats: [
        { value: '15K+', label: 'Clients satisfaits' },
        { value: '95%', label: "Taux d'approbation" },
        { value: '5+', label: "Années d'expérience" }
      ],
      images: [
        { src: '/acceuil.jpg', alt: 'Intérieur agence Oasis Finance' },
        { src: '/accueil2.jpg', alt: 'Façade Oasis Finance' },
        { src: '/tofs_4.jpg', alt: 'Équipe Oasis Finance' }
      ]
    }
  }
}
</script>

<style scoped>
.about-section {
  padding: 6rem 2rem;
  background: var(--primary-blue);
  position: relative;
  overflow: hidden;
}

.about-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 80%;
  height: 200%;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.3) 0%, transparent 60%);
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

.about-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  position: relative;
  z-index: 1;
}

.about-content {
  color: var(--white);
}

.section-label {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: rgba(245, 158, 11, 0.2);
  color: var(--accent-gold);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border-radius: 50px;
  margin-bottom: 1rem;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 700;
  color: var(--white);
  line-height: 1.2;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.7;
}

.about-text {
  margin-top: 1.5rem;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.8;
}

.about-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
  padding-top: 3rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-family: var(--font-display);
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--accent-gold);
}

.stat-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 0.25rem;
}

.about-images {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.about-img {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  transition: var(--transition-base);
}

.about-img:first-child {
  grid-row: span 2;
}

.about-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: var(--transition-slow);
}

.about-img:hover img {
  transform: scale(1.05);
}

@media (max-width: 1024px) {
  .about-grid {
    grid-template-columns: 1fr;
  }

  .about-images {
    order: -1;
  }
}

@media (max-width: 768px) {
  .about-section {
    padding: 4rem 1.5rem;
  }

  .about-stats {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .about-images {
    grid-template-columns: 1fr;
  }

  .about-img:first-child {
    grid-row: span 1;
  }
}
</style>
